<div class="container">
  <form
    class="agreementForm"
    [formGroup]="agreementForm"
    (ngSubmit)="agreementDetailsSubmit()"
  >
    <div class="row">
      <div class="col-md-2">
        <button
          type="submit"
          [ngClass]="!showCaptcha ? 'btn btn-light disabled' : 'orangeBtn'"
          [disabled]="!showCaptcha"
          [ngStyle]="{'background-color': primaryColor}"
        >
          Submit Referral
        </button>
      </div>
    </div>
  </form>
</div>
